import { Component, EventEmitter, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '@service/users.service';
import { AuthService } from '@service/auth.service';
import { MentorService } from '@service/mentor.service';
import { ModalBuyWordsComponent } from '@component/modal-buy-words/modal-buy-words.component';

@Component({
  selector: 'app-modal-openai-dialog',
  templateUrl: './modal-openai-dialog.component.html',
  styleUrls: ['./modal-openai-dialog.component.scss']
})
export class ModalOpenaiDialogComponent implements OnInit {

  valueSender = new EventEmitter<string>();

  isChecked: boolean = false;
  countWords: number;
  currentWords: number;
  maxWords: number;
  isAccepted: boolean;
  requestAiLoading: boolean = false;

  modalOptions: NgbModalOptions;

  public suggestions = "";
  public splitedSuggestions = [];
  public selectedSuggestion = '';

  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private usersService: UsersService,
    public mentorService: MentorService,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.usersService.getWordsCount(this.authService.user.id).subscribe((res) => {
      this.currentWords = res.words
      this.maxWords = res.max_words
    });
  }

  async generateTitle(title: string) {
    if (this.currentWords >= this.maxWords) {
      const modalRef = this.modalService.open(ModalBuyWordsComponent, { size: 'sm' });

      await modalRef.result.then(() => {
        this.activeModal.dismiss();
      }).catch(() => {
        this.activeModal.close();
      });

      return;
    }

    this.requestAiLoading = true;
    this.splitedSuggestions = [];
    await this.mentorService.callOpenAi("crie 5 títulos de trabalhos acadêmicos sobre ", title, "gpt-3.5-turbo-instruct", 150, "list", true)
      .then((res) => {
        for(let c = 0; c < res.length; c++) {
          if(res[c].length > 0) {
            this.splitedSuggestions.push(res[c]);
          }
        }
    }).catch((err) => {
        console.error(err);
    });
    this.requestAiLoading = false;
  }

  title() {
    this.valueSender.emit(this.selectedSuggestion);
    this.activeModal.close();
  }

  hasSuggestions(): boolean {
    return this.splitedSuggestions.length > 0;
  }

  onSelected(value:string): void {
		this.selectedSuggestion = value;
	}

  passSuggestion() {
    this.activeModal.close(this.selectedSuggestion);
  }
}
